var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowUp = function SvgIconArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.308 8.002a.751.751 0 0 1-1.06.055l-6.998-6.3-6.998 6.3a.754.754 0 0 1-1.06-.055.753.753 0 0 1 .056-1.06L7.706.192a.753.753 0 0 1 1.005 0l7.458 6.75c.392.277.415.75.139 1.06Z"
  })));
};
export default SvgIconArrowUp;